import { render, staticRenderFns } from "./card-review-expert.vue?vue&type=template&id=13e794a6&scoped=true"
import script from "./card-review-expert.vue?vue&type=script&lang=js"
export * from "./card-review-expert.vue?vue&type=script&lang=js"
import style0 from "./card-review-expert.vue?vue&type=style&index=0&id=13e794a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e794a6",
  null
  
)

export default component.exports